import endPoint from "./../../libs/endPoint/avaliacaoinstitucional/QuestionariosRoutes.js";
import ApiServices from "@/services/uteis/ApiServices.js";
class QuestionariosServices {
  constructor() {
    this.endPoint = endPoint;
  }

  async listar(params = {}) {
    try {
      const url = this.endPoint.main;
      console.log(url);
      const { data } = await ApiServices.get(url, params);
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }

  async listarAbertos(params = {}) {
    try {
      const url = this.endPoint.abertos;
      console.log(url);
      const { data } = await ApiServices.get(url, params);
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }

  async clonarQuestionario(params = {}) {
    try {
      const url = this.endPoint.cloanar;
      const { data } = await ApiServices.post(url, params);
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }
} // fim classe
export default new QuestionariosServices();
